
import React, { useReducer } from "react";
import axios2 from 'services/axios2';

import {useParams} from "react-router-dom";
import {Link,hashHistory} from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';

import FigureItem  from "components/FigureItem";

import { withRouterJim } from "router/withRouterJim";

//--- CONTEXT API -----------
import { useStore, useDispatch, StoreContext } from "store/StoreProvider";
import {types, storeReducer} from "store/StoreReducer"


import { NotificationContainer, NotificationManager } from 'react-notifications';
import {
  Table,
  Button,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  ModalFooter,
  ToastHeader,
} from "reactstrap";

const cbo=[
  {  value:'1', label: 'label1'},
]


const initialForm = {
  idd:0,
  ope:'n',
  
};

//$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$
class Participantes extends React.Component {
  state = {

    modalImagen: false,
        
    form: Object.assign({}, initialForm),
    data: [],/* lista  */
    
  };
   //---------------- CONTEXT API ------------------
    //const store = useStore();
    

  //---------------------------------
  componentDidMount() {
    //--limpiamos el array de prueba
    this.setState({data:[]});
    
    this.cargar_estudiantes();

    const date = new Date();
    const defaultValue = date.toLocaleDateString('en-CA');
  
    
  }
  //----------------especial, actualiza valores del form -------------------------------
  handleChangeForm = (e) => {
    //requerimos la prop name='?' en cada control
    
    //--- esto lo hacemos porque en vez de utilizar valores true, false
    //--- tenemos que utilizar 1, 0
    if(e.target.type==="checkbox"){

      let res = e.target.checked? 1:0;        
      this.setState({
        form:{
          ...this.state.form,
          [e.target.name]: res,
        }
      })
    }else{
      this.setState({
        form: {
          ...this.state.form,
          [e.target.name]: e.target.value,
        },
      });
    }
  };
  //-------------------------------------------
  /*
    "id_mate": 20,
    "id_carre": 4,
    "id_cate": 99,
    "sigla": "SIM-101",
    "nombre": "SEGURIDAD INDUSTRIAL Y MEDIO AMBIENTE",
    "fecha_ini": null,
    "fecha_fin": null,
    "visible_sn": 0,
    "id_grupo": 1,
    "id_siseval": 0,
    "foto": "",
    "resumen": "",
    "estado": 0
   */
  cargar_estudiantes=()=>{
    console.log("cargar_estudiantes")
    //let id_est = this.props.store.user.id_est;
    let id_mate = this.props.store.materia.id_mate;
    let id_peri = this.props.store.user.id_peri;
    let periodo = this.props.store.user.periodo;

    let param = { 
      id_mate: id_mate,
      id_peri: id_peri,
    }
    console.log(param)
    axios2.post("participantes_get_list", param)
    .then(res => {
        console.log(res.data)
        if(res.data.length>0){ 
            this.setState({data: res.data});
        }else{
            NotificationManager.error('No existen datos');
        }
    }).catch(error => {
        alert("---- Existio un error ---");
        console.log(error);
    });
  }
  //-----------------------------------------
  // retorna id_mate, nombre, sigla
  onClickArticle=(item)=>{
    console.log("onClickArticle");
    console.log(item)
    //guardamos el usuario en el localstorage
    //localStorage.setItem("materia", JSON.stringify(item));
    //---------- lo colocamos a el STORE ------------------ 
    let materia = { id_mate:item.id_mate, nombre: item.nombre, sigla: item.sigla ,grupo: item.id_grupo, foto: item.foto }
    this.props.dispatch({ type: types.setMateria, payload: materia }); 
    //dispatch({type: types.authLogin, payload: response.user}); 
    //----------  -----------------------------------------

    let ruta = `/curso_main/${item.id_mate}`;
    //--redireccionamos
    this.props.navigate(ruta);

  }
  //------------------------------
  render() {
    return(
      <div>
        {/* ---   --- */}
        { //JSON.stringify(this.state.form)
        }
        <div className="escritorio center-align p-3">
          <ul className="lista_aulas">
            {this.state.data.map((item,index) => ( 
                <li key={index}>
                  
                  <FigureItem  
                      nombre={item.nomape_tmp}        
                      id={item.id_est}   
                      imgSrc={process.env.REACT_APP_AFILES + item.foto_path1}
                      //onClick={()=> this.onClickArticle(item) }
                  />
                </li>
            ))}
            
          </ul>
        </div>
        

        <NotificationContainer/>
      </div>
    )
  }
}

//------------para que soporte la funcionalidad de parametros
export default withRouterJim(Participantes);